import { render } from "./MemberDetailModern.vue?vue&type=template&id=4172e013&scoped=true"
import script from "./MemberDetailModern.vue?vue&type=script&lang=js"
export * from "./MemberDetailModern.vue?vue&type=script&lang=js"

import "./MemberDetailModern.vue?vue&type=style&index=0&id=4172e013&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4172e013"]])

export default __exports__